export default "__VITE_ASSET__BjasMSJD__"